export const chunkArray = (
  data: { country: string; id: string }[],
  chunkSize: number
) => {
  const chunk1 = data.slice(0, chunkSize)
  const chunk2 = data.slice(chunkSize, data.length)

  return { firstChunk: chunk1, remainingChunk: chunk2 }
}
